import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import React from "react";
import { useLocation, useNavigate } from "react-router";

type Props = {
    title: string;
    children: React.ReactNode;
    expectedPaths: string[];
};

export default function CommonDialog({
    title,
    children,
    expectedPaths,
}: Props) {
    const location = useLocation();
    const navigate = useNavigate();

    const open = expectedPaths.some((path) => location.pathname.includes(path));

    const handleClose = () => {
        // Navigate back to the parent route (remove the dialog path segment)
        const pathParts = location.pathname.split("/");
        const parentPath = pathParts.slice(0, -1).join("/");
        navigate(parentPath);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                    height: "90vh",
                    maxHeight: "90vh",
                },
            }}
        >
            <DialogTitle>{title}</DialogTitle>
            <Divider sx={{ opacity: 0.6 }} />
            <DialogContent sx={{ p: 0, flex: 1, overflow: "scroll" }}>
                {children}
            </DialogContent>
            <Divider sx={{ opacity: 0.6 }} />
            <DialogActions>
                <Button onClick={handleClose} variant="contained">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}
